export default "__VITE_ASSET__Cn$P9pYV__"